import React, { useState, useRef, useEffect } from 'react';

const videos = [
  { src: '/videos/bio-1.mp4', poster: '/videos/bio-poster-1.jpg' },
  { src: '/videos/bio-2.mp4', poster: '/videos/bio-poster-2.jpg' },
  { src: '/videos/bio-3.mp4', poster: '/videos/bio-poster-3.jpg' },
  { src: '/videos/bio-4.mp4', poster: '/videos/bio-poster-4.jpg' },
  { src: '/videos/bio-5.mp4', poster: '/videos/bio-poster-5.jpg' },
];

const Hero = () => {
  const [index, setIndex] = useState(0);
  const fgRef = useRef(null);
  const bgRef = useRef(null);

  const handleEnded = () => setIndex((i) => (i + 1) % videos.length);

  useEffect(() => {
    const fg = fgRef.current;
    const bg = bgRef.current;
    if (fg) {
      fg.muted = true;
      fg.play().catch(() => {});
    }
    if (bg) {
      bg.muted = true;
      bg.play().catch(() => {});
    }
  }, [index]);

  const current = videos[index];

  return (
    <section className="relative w-full overflow-hidden bg-ink">
      {/* Stage that goes from top of page (behind navbar) */}
      <div className="relative w-full min-h-[100svh]">
        {/* Blurred background of current video filling everything */}
        <video
          ref={bgRef}
          key={`bg-${current.src}`}
          src={current.src}
          poster={current.poster}
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 w-full h-full object-cover scale-110 blur-3xl opacity-50"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-[#0b0807]/55" />

        {/* Foreground video — full, never cropped */}
        <div className="relative z-[1] flex items-center justify-center pt-28 md:pt-32 pb-4 px-4">
          <video
            ref={fgRef}
            key={current.src}
            src={current.src}
            poster={current.poster}
            autoPlay
            muted
            playsInline
            onEnded={handleEnded}
            className="block max-h-[62svh] md:max-h-[70svh] w-auto max-w-full rounded-md shadow-[0_30px_120px_-20px_rgba(0,0,0,0.9)]"
          />
        </div>

        {/* Bottom dark gradient for text legibility */}
        <div className="absolute inset-x-0 bottom-0 h-[55%] bg-gradient-to-t from-[#0b0807] via-[#0b0807]/85 to-transparent pointer-events-none" />

        {/* Hero text overlay — anchored to bottom */}
        <div className="relative z-[2] -mt-6 md:-mt-10 pb-12 md:pb-16">
          <div className="max-w-6xl mx-auto px-6 text-center fade-up">
            <div className="inline-flex items-center justify-center rounded-full bg-cream text-[#0b0807] px-5 py-1.5 text-[12px] font-medium tracking-[0.18em] uppercase mb-5 shadow-lg">
              Jundiaí — SP
            </div>

            <h1 className="font-display text-[32px] sm:text-[44px] md:text-[60px] lg:text-[72px] leading-[1.04] text-cream drop-shadow-2xl">
              Não é sobre cortar cabelo.<br className="hidden md:block" />
              <span className="text-cream/85">É sobre experiência, identidade e padrão.</span>
            </h1>

            <p className="mt-5 md:mt-6 text-cream-soft text-[14.5px] md:text-[17px] max-w-2xl mx-auto leading-relaxed">
              Muito além de uma barbearia comum. A BRN nasceu da inquietação de fazer diferente: estrutura organizada,
              atendimento padronizado e profissionais preparados para entregar acima da média.
            </p>

            {/* Progress dots */}
            <div className="mt-7 flex items-center justify-center gap-2">
              {videos.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setIndex(i)}
                  className={`h-[3px] rounded-full transition-all ${
                    i === index ? 'w-10 bg-cream' : 'w-5 bg-cream/30 hover:bg-cream/60'
                  }`}
                  aria-label={`Vídeo ${i + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
